/* eslint-disable no-plusplus */
import * as crypto from "crypto";

export const flattenObject = (obj, _parentKeys) => {
    const parentKeys = _parentKeys || '';

    const flattened = {};
    if (typeof obj !== 'object' || obj == null) {
        if (parentKeys) { flattened[parentKeys.substring(1)] = obj; }
        else { return obj; }
    }
    else if (Array.isArray(obj)) {
        for (let i = 0; i < obj.length; ++i) {
            Object.assign(flattened, flattenObject(obj[i], `${parentKeys}.${i}`));
        }
    }
    else {
        Object.keys(obj).forEach(key => {
            Object.assign(flattened, flattenObject(obj[key], `${parentKeys}.${key}`));
        });
    }
    return flattened;
};

export const generateRsaSignature = (authType, rsaSignaturePieces, requestHeaders, gqlArguments) => {
    if (authType !== 'apiKey') { return null; }
    if (!rsaSignaturePieces) { return null; }

    const { addAutomaticSignature, passphrase, privateKey } = rsaSignaturePieces;
    if (!addAutomaticSignature || !passphrase || !privateKey) { return null; }

    const userId = requestHeaders['x-user-id'];
    if (!userId) { return null; }

    const deviceId = requestHeaders['x-device-id'];
    if (!deviceId) { return null; }

    const data = {
        userId,
        deviceId,
        endpoint: gqlArguments.operationName,
        arguments: gqlArguments.variables,
    };
    const flattenedData = flattenObject(data);
    const dataStr = JSON.stringify(flattenedData, Object.keys(flattenedData).sort());

    const sign = crypto.createSign('sha256');
    sign.update(dataStr);
    const signature = sign.sign({ key: privateKey, passphrase }).toString('hex');
    
    return signature;
};